import React from "react"

const correctionsContent = {
  openingParagraph: 'The Department of Corrections is responsible for: ',
  openingList: (
    <ul className="list">
      <li>
        managing Colorado’s state correctional facilities;
      </li>
      <li>
        supervising the population of offenders in the custody of the department; and
      </li>
      <li>
        developing educational, treatment, and correctional industries programs that have a rehabilitative or therapeutic value for inmates.
      </li>
    </ul>
  ),
  majorSpendingParagraph: (
    <>
      State employee compensation is the primary factor driving the department’s budget, accounting for 66.3 percent of the $899.8 million General Fund appropriated to the department for FY 2022-23. Appropriations for state employee compensation depend on two key factors: (1) the number of employees utilized to manage the State’s inmate and parole populations, and (2) policy decisions that affect salaries and benefits.
    <br />
      <br />
      <a className="link" href="https://leg.colorado.gov/content/budget" target="_blank" rel="noopener noreferrer">More on the Corrections Budget</a>
    </>
  )
}

export default correctionsContent
